<!-- breadcrumb start -->
<div class="breadcrumb-section">
    <div class="container">
        <div  class="fx-row fx-main-between fx-cross-start">
            <div class="breadcrumb-title  pr-15 fx-flex-100 gt-sm-fx-flex-45">
          <div class="page-title">
            <h4>{{ title }}</h4>
          </div>
        </div>
        <div class="breadcrumb-path fx-flex-100 gt-sm-fx-flex-45">
                <ol class="breadcrumb fx-row">
                  <li class="breadcrumb-item-home"><a [routerLink]="'/home'">Home</a></li>
                  <li class="breadcrumb-item">/</li>
                  <li class="breadcrumb-item-path active" aria-current="page">{{ breadcrumb }}</li>
                </ol>
        </div>
          
      
    </div>
    </div>
  </div>
  <!-- breadcrumb End -->